import { LoadingButton } from "@mui/lab";
import { Alert, Link, Stack } from "@mui/material";
import { Link as RouterLink } from "@tanstack/react-router";
import { FormProvider, RHFCheckbox, RHFTextField } from "src/components/hook-form";
import useLocales from "src/hooks/useLocales";
import { PATH_AUTH } from "src/utils/paths";

import { useLoginForm } from "../hooks/useLoginForm";
import PasswordInput from "./PasswordInput";

// ----------------------------------------------------------------------

export default function LoginForm() {
	const { translate } = useLocales();

	const { methods, isLoading, onSubmit, errorMessage } = useLoginForm();

	return (
		<FormProvider methods={methods} onSubmit={onSubmit}>
			<Stack spacing={3}>
				{errorMessage !== "" && <Alert severity='error'>{errorMessage}</Alert>}
				<RHFTextField label={translate("Email")} name='email' />
				<PasswordInput />
			</Stack>
			<Stack alignItems='center' direction='row' justifyContent='space-between' sx={{ my: 2 }}>
				<RHFCheckbox label={translate("login.remember_me") as string} name='remember' />
				<Link component={RouterLink} to={PATH_AUTH.resetPassword} variant='subtitle2'>
					{translate("login.remember_password")}
				</Link>
			</Stack>
			<LoadingButton fullWidth loading={isLoading} size='large' type='submit' variant='contained'>
				{translate("login.title")}
			</LoadingButton>
		</FormProvider>
	);
}
